import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Artificial intelligence governance is a pressing policy issue. AI systems
are rapidly being adopted to assist, or independently complete, many tasks. The
result is a deserved focus on the safe development and deployment of AI
systems. Governments are putting forth AI ethics principles, compiling AI
inventories, and mandating AI risk assessments. But these efforts require a
standardized approach to classifying the varied types of AI systems in use.`}</p>
    <p>{`To that end, CSET partnered with the Organization for Economic Cooperation and
Development (OECD) AI Policy Observatory and U.S. Department of Homeland
Security (DHS) Office of Strategy, Policy, and Plans to develop several
frameworks for classifying AI systems. Once defined, these frameworks were
tested for clarity and ease of use in a survey, where respondents were asked to
classify example AI systems according to the different frameworks. This
interactive guide will walk you through the basics of each framework and how
respondents fared when classifying example systems using each framework. For more
details on the process and methodology, please see the
`}<a parentName="p" {...{
        "href": "https://cset.georgetown.edu/publication/classifying-ai-systems/"
      }}>{`full report`}</a>{` and the
`}<a parentName="p" {...{
        "href": "https://cset.georgetown.edu/wp-content/uploads/Classifying-AI-Systems_Survey-Instrument.pdf"
      }}>{`survey instrument`}</a>{`.
You can also anonymously try your hand at classifying example systems using
the frameworks by clicking "take the survey" below.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      